export default __webpack_public_path__ + "assets/images/avatar.f696e8.jpg";